export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://scienzahealth.com/#website",
  "url": "https://scienzahealth.com",
  "name": "Scienza Health - Digital Human® AI Platform",
  "description": "Transforming healthcare delivery with AI-powered Digital Human® for patient access automation, clinical support, and care optimization",
  "publisher": {
    "@id": "https://scienzahealth.com/#organization"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://scienzahealth.com/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  },
  "mainEntity": {
    "@type": "MedicalOrganization",
    "@id": "https://scienzahealth.com/#medical-organization",
    "name": "Scienza Health",
    "alternateName": "Digital Human® AI Platform",
    "description": "Advanced AI-powered Digital Human® platform for healthcare delivery automation",
    "url": "https://scienzahealth.com",
    "logo": "https://scienzahealth.com/mcai_logo_green.svg",
    "image": "https://scienzahealth.com/images/scienza_social_preview.png",
    "medicalSpecialty": [
      "Cognitive Health Monitoring",
      "Patient Access Automation", 
      "Clinical Support Systems",
      "Healthcare AI Solutions"
    ],
    "serviceType": [
      "AI-Powered Patient Screening",
      "Digital Human® Interaction",
      "Clinical Decision Support",
      "Healthcare Process Automation"
    ]
  }
};